import clsx from 'clsx';
import React from 'react';
import './UiPadding.css';
export function UiPadding(_a) {
    var outer = _a.outer, inner = _a.inner, negative = _a.negative, horizontal = _a.horizontal, vertical = _a.vertical, top = _a.top, bottom = _a.bottom, left = _a.left, className = _a.className, children = _a.children;
    var classes = clsx('UiPadding', outer && "outer-" + outer, inner && "inner-" + inner, horizontal && "horizontal-" + horizontal, vertical && "vertical-" + vertical, negative && "negative-" + negative, top && "top-" + top, bottom && "bottom-" + bottom, left && "left-" + left, className);
    return React.createElement("div", { className: classes }, children);
}
